import * as React from "react";
import { forwardRef, memo } from "react";
const SvgSl = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 9 6", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#0072C6", d: "M0 0h9v6H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#FFF", d: "M0 0h9v4H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#1EB53A", d: "M0 0h9v2H0z" }));
const ForwardRef = forwardRef(SvgSl);
const Memo = memo(ForwardRef);
export default Memo;
